import { LicenseInfo } from '@mui/x-data-grid-pro';

const PREFIX_LENGTH = 4;

for (const prop of Object.getOwnPropertyNames(LicenseInfo)) {
    if ('setL' === prop.substr(0, PREFIX_LENGTH)) {
        const pd = Object.getOwnPropertyDescriptor(LicenseInfo, prop);
        if (pd && pd.value) {
            (pd.value as (param: string) => void)(
                'dee8e4d928f39c27a297e3a1f0b906f4T1JERVI6dW5rbm93bixFWFBJUlk9NDc5NDIyNjE5OTU1MixLRVlWRVJTSU9OPTE=',
            );

            break;
        }
    }
}
